import config from '@/config';

const molweSiteOrigin = config.PUBLIC_URL.replace(/\/$/, '');

export const VRNFEST_YOUTUBE_SUB_URL = 'https://www.youtube.com/@Molwe_ru?sub_confirmation=1';

export const VRNFEST_MOLWE_HOME_URL = `${molweSiteOrigin}/`;

export const VRNFEST_REGISTRATION_REF = 'vrnfest';

export const VRNFEST_MOLWE_REGISTER_URL = `${molweSiteOrigin}/?register=1&ref=${encodeURIComponent(VRNFEST_REGISTRATION_REF)}`;

export const VRNFEST_TELEGRAM_MOLWE = 'https://t.me/molweru';

export const VRNFEST_TELEGRAM_LIFE = 'https://t.me/ficlife';

export const VRNFEST_CONTEST_TERMS_PDF_PATH = '/vrnfest/usloviya-konkursa.pdf';

export const VRNFEST_CONTEST_TERMS_PAGE_PATH = '/vrnfest/usloviya';

export const VRNFEST_GET_MANGA_MODAL_BG_PATH = '/images/vrnfest/get-manga-dialog-bg.webp';
